export function degreeToRadian(deg: number) {
  return deg * (Math.PI / 180);
}

export function radianToDegree(rad: number) {
  return rad * (180 / Math.PI);
}
